
import PartnersHero from './components/PartnersHero';
import PartnersGrid from './components/PartnersGrid';
import PartnersCTA from './components/PartnersCTA';
import Header from '../home/components/Header';
import Footer from '../home/components/Footer';

export default function PartnersPage() {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <PartnersHero />
      <PartnersGrid />
      <PartnersCTA />
      <Footer />
    </div>
  );
}
